import React from 'react';
import { Helmet } from 'react-helmet-async';

// Meta tag dinamici per SEO e anteprime social (Open Graph) + dati strutturati JSON-LD.
// `canonical` è il path/URL canonico della pagina; `jsonLd` un oggetto schema.org
// (o un array di oggetti) iniettato come <script type="application/ld+json">.
// Host canonico = senza www (www.festedapiccoli.it fa 301 → festedapiccoli.it).
const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://festedapiccoli.it').replace(/\/$/, '');

function Seo({ title, description, image, type = 'website', canonical, jsonLd }) {
  const fullTitle = title ? `${title} · Feste Da Piccoli` : 'Feste Da Piccoli';
  const desc = description || 'Trova location, intrattenimento e allestimenti per le feste di compleanno dei tuoi bambini.';
  const canonicalUrl = canonical
    ? (canonical.startsWith('http') ? canonical : `${SITE_URL}${canonical}`)
    : null;
  const blocchi = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  // Senza un'immagine propria della pagina, l'anteprima dei link usa il logo del sito.
  const ogImage = image || `${SITE_URL}/logo-balloon.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      {blocchi.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export default Seo;
